<div class="address-chooser">
    <div class="header-container">
        <h2>Address Search Results</h2>
        <button class="mat-button icon-button close" aria-label="close dialog" [mat-dialog-close]="">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-card>
        <mat-card-content>
            <p>
                <span *ngIf="address"
                    >We are unable to locate a matching address in Google Maps. Please confirm the address and time zone listed below are
                    correct and press Continue, or press Cancel to modify the address.
                </span>
            </p>
            <div class="addressOption" [ngClass]="{ selectedAddressWrapper: true }">
                <p>
                    {{ address.address }}, <br />
                    {{ address.city }}, {{ address.state }} {{ address.zipcode }}
                </p>
                <p>{{ address.timezonename }}</p>
            </div>
            <mat-card-actions class="formActionButtonGroup clearfix">
                <button mat-stroked-button [mat-dialog-close]="" class="cancel-btn">Cancel</button>
                <button mat-raised-button color="primary" [mat-dialog-close]="address" class="new-primary-button continue-btn">Continue</button>
            </mat-card-actions>
        </mat-card-content>
    </mat-card>
</div>
